"use strict";

exports.__esModule = true;
exports.SvcAiError = void 0;
exports.callSvcAi = callSvcAi;
exports.describeSvcAiError = describeSvcAiError;
exports.generateReport = exports.generateDashboard = exports.editReport = exports.editDashboard = void 0;
exports.getSvcAiBase = getSvcAiBase;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
// The svc-ai routes, per notes/frontend-api-guide.md: all POST, all JSON,
// tens of seconds each. Only these calls go to the AI service; the rest of
// the app keeps talking to its usual API.
var AI_PATH = "/api/v1/ai";
var SvcAiError = exports.SvcAiError = /*#__PURE__*/function (_Error) {
  function SvcAiError(message, status, requestId) {
    var _this;
    _this = _Error.call(this, message) || this;
    _this.name = "SvcAiError";
    _this.status = status;
    _this.requestId = requestId;
    return _this;
  }
  _inheritsLoose(SvcAiError, _Error);
  return SvcAiError;
}(/*#__PURE__*/_wrapNativeSuper(Error));
function trimSlash(url) {
  return url && url.endsWith("/") ? url.slice(0, -1) : url;
}

/**
 * Where svc-ai lives: `env.aiURL` when the deployment names one (the local
 * service during development), otherwise the same API host as everything
 * else.
 */
function getSvcAiBase(env) {
  return trimSlash(env && (env.aiURL || env.apiURL) || "");
}
function callSvcAi(_x, _x2, _x3) {
  return _callSvcAi.apply(this, arguments);
}
function _callSvcAi() {
  _callSvcAi = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(path, body, _ref) {
    var token, plant, baseUrl, signal, response, requestId, message, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          token = _ref.token, plant = _ref.plant, baseUrl = _ref.baseUrl, signal = _ref.signal;
          _context.n = 1;
          return fetch("" + baseUrl + AI_PATH + path, {
            method: "POST",
            headers: {
              Authorization: "Bearer " + token,
              "X-Tenant": plant,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(body),
            signal: signal
          });
        case 1:
          response = _context.v;
          requestId = response.headers.get("X-Request-Id");
          if (response.ok) {
            _context.n = 6;
            break;
          }
          _context.p = 2;
          _context.n = 3;
          return response.json();
        case 3:
          message = _context.v.message;
          _context.n = 5;
          break;
        case 4:
          _context.p = 4;
          _t = _context.v;
          message = undefined;
        case 5:
          throw new SvcAiError(message || "The AI service responded with " + response.status, response.status, requestId);
        case 6:
          return _context.a(2, response.json());
      }
    }, _callee, null, [[2, 4]]);
  }));
  return _callSvcAi.apply(this, arguments);
}
var generateDashboard = exports.generateDashboard = function generateDashboard(prompt, options) {
  return callSvcAi("/dashboards/generate", {
    prompt: prompt
  }, options);
};
var editDashboard = exports.editDashboard = function editDashboard(prompt, element, options) {
  return callSvcAi("/dashboards/edit", {
    prompt: prompt,
    element: element
  }, options);
};
var generateReport = exports.generateReport = function generateReport(prompt, options) {
  return callSvcAi("/reports/generate", {
    prompt: prompt
  }, options);
};
var editReport = exports.editReport = function editReport(prompt, element, options) {
  return callSvcAi("/reports/edit", {
    prompt: prompt,
    element: element
  }, options);
};

/**
 * What to tell the user for a failed call, per the service's own guidance.
 */
function describeSvcAiError(error, translate) {
  var t = function t(id, fallback) {
    return translate ? translate(id, fallback) : fallback;
  };
  if (!error) {
    return "";
  }
  if (error.name === "AbortError") {
    return t("AiAuthoring.error.aborted", "The request was cancelled.");
  }
  if (error.status === 504 || error.status === 408) {
    return t("AiAuthoring.error.timeout", "That took too long. Try a narrower prompt.");
  }
  if (error.status === 502) {
    return t("AiAuthoring.error.upstream", "The plant's data could not be read right now. Try again later.");
  }
  if (error.status === 401 || error.status === 403) {
    return t("AiAuthoring.error.forbidden", "You are not allowed to do this, or the AI service does not accept this session.");
  }
  if (error instanceof TypeError) {
    return t("AiAuthoring.error.network", "The AI service could not be reached.");
  }
  return error.message || t("AiAuthoring.error.generic", "Something went wrong.");
}